import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=d503cd8e"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NestedMenu: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/NestedMenu.vue').default,HotProducts: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/HotProducts.vue').default,Section: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Section.vue').default})
